import BaseApi from '../base/base'
import AiChatQuestion from "../../models/ai_chat_question";

export default class AiChatQuestionApi extends BaseApi {
  constructor() {
    super()
    this.path = '/ai_chat_questions'
  }
  async index(params: { context: string[], targetableId: any, targetableType: string }) {
    this.path = '/ai_chat_questions'
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new AiChatQuestion(element)
    })
  }
}
